import React, { createContext, useContext, useRef, useState } from "react";


const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const timerRef = useRef(null);

  const showNotification = (message, severity = "success") => {
  if (timerRef.current) {
    clearTimeout(timerRef.current);
  }

  setNotification({
    open: true,
    message,
    severity,
  });

  timerRef.current = setTimeout(() => {
    setNotification((prev) => ({
      ...prev,
      open: false,
    }));
  }, 5000);
};

  const closeNotification = () => {
  if (timerRef.current) {
    clearTimeout(timerRef.current);
  }

  setNotification((prev) => ({
    ...prev,
    open: false,
  }));
};

  return (
    <NotificationContext.Provider
      value={{
        notification,
        showNotification,
        closeNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);